import React from 'react';
import './main.less';

import { Link } from 'react-router';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';

import { namespace, actions, selectors } from './';

import wrapMain from '../../wrap-main';

import InputField from '../../../shared/form-elements/input';
import { isRequired } from '../../../shared/form/validation';

function ProgramsCategoryEditor({ intl, ...props }) {
	return (
		<div className='form-container'>
			<div className='form-container__head'>
				<h2 className='icon-edit'>
					{intl('create/edit offer category')}
				</h2>
			</div>
			<div className='form-container__body'>
				<form onSubmit={props.handleSubmit}>
					<div className='programs-category-editor-fields'>
						<Field
							name='name_en'
							component={InputField}
							validate={[isRequired]}
							placeholder={`${intl('Name')} (EN)`}
						/>
						<Field
							name='name_ru'
							component={InputField}
							validate={[isRequired]}
							placeholder={`${intl('Name')} (RU)`}
						/>
					</div>
					<div className='banners-buttons'>
						<button className='ui-btn ui-btn-primary'>
							{intl('Save')}
						</button>
						<Link
							className='ui-btn ui-btn-cancel'
							to='/programs/categories'
						>
							{intl('Cancel')}
						</Link>
					</div>
				</form>
			</div>
		</div>
	);
}

function mapStateToProps(state) {
	return {
		initialValues: selectors.select(state, 'data'),
		isLoading: selectors.select(state, 'isLoading'),
		isError: selectors.select(state, 'isError')
	};
}

const Main = reduxForm({ form: `${namespace}Form`, enableReinitialize: true })(ProgramsCategoryEditor);

export default connect(mapStateToProps, actions.own)(wrapMain(Main));


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/category/editor/main.js